import { createFileRoute } from "@tanstack/react-router";
import { ColorsIndex, colorsIndexHeadDa } from "@/pages/ColorsIndex";

export const Route = createFileRoute("/farver/")({
  head: colorsIndexHeadDa,
  component: ColorsIndex,
});
